<template>
    <div class="h-100 w-100">
        <c-site-contract-flip-card
            v-if      = "contractValid"
            :title    = "$t('contract.mnt.title')"
            :contract = "contract"
            :edit     = "true"
            :unit     = "unit"
            @readonly = "onReadonly"
            @store    = "onStore"
        >
            <template v-slot:front>
                <c-contract-mnt-terms
                    :contract  = "contract"
                    :readonly  = "readonly"
                    :unit-mode = "true"
                    class      = "mt-3"
                />
                <v-row class="no-frame pt-6">
                    <f-read-only-field
                        class  = "w-100 ro-gap"
                        :label = "$t('contract.mnt.service')"
                        :value = "service"
                        filled
                    />
                </v-row>
                <v-row class="no-frame">
                    <f-read-only-field
                        class  = "w-100 ro-gap"
                        :label = "$t('contract.mnt.prmanager')"
                        :value = "manager"
                        filled
                    />
                </v-row>

            </template>
        </c-site-contract-flip-card>

        <div
            v-if  = "!contractValid"
            class = "w-100 h-100"
        >
            <c-column-header
                label = "Wartung (kein Vertrag)"
                class  = "primary mb-1 w-100"
            />
            <div class  = "lm-border mb-1 w-100" style="height: calc(100% - 29px)">

            </div>
        </div>
    </div>
</template>

<script>

import Contract              from "@/modules/msd/company/contract/service/Contract";
import Core                  from "@/modules/core/service/Core";
import CSiteContractFlipCard from "@/modules/msd/company/contract/components/controls/common/CSiteContractFlipCard.vue";
import CContractMntTerms     from "@/modules/msd/company/contract/components/controls/mnt/CContractMntTerms.vue";
import CColumnHeader         from "@/modules/core/components/utils/CColumnHeader.vue";
import FReadOnlyField        from "@/modules/core/components/utils/FReadOnlyField.vue";
import SiteContractMixin     from "@/modules/msd/company/contract/components/controls/common/SiteContractMixin";

export default {
    name: "CSiteContractMnt",

    mixins: [
        SiteContractMixin
    ],

    components: {
        FReadOnlyField,
        CColumnHeader,
        CContractMntTerms,
        CSiteContractFlipCard,
    },

    props: {
        contract: {
            required : true,
            type     : Object,
            default  : () => {
                return {
                    incidentsIncluded: null,
                    maxIncidentCosts : null,
                    service          : null,
                    prmRole          : null,
                    costPerYear      : null,
                    countPerYear     : null
                }
            }
        },
        unit: {
        }
    },

    computed: {
        service () {
            if (this.contract && this.contract.service) {
                return this.contract.service.name;
            }

            return null;
        },

        manager () {
            if (this.contract && this.contract.prmRole) {
                return this.contract.prmRole.name;
            }

            return null;
        }
    },

    methods: {
        onStore () {
            Contract.unit.saveMnt(this.unitId, this.contract.id,{
                start: this.contract.unit.start,
                end  : this.contract.unit.end,
                costs: this.contract.unit.costs,
                count: this.contract.unit.count,
            }).then(() => {
                Core.message.hint(this, this.$t('contract.edit.stored'));
            })
        }
    }
}
</script>

<style scoped>

</style>